import React, { memo, useContext, useCallback } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import TableIcon from 'mdi-react/ViewColumnIcon';
import ListIcon from 'mdi-react/ViewAgendaIcon';
import GridIcon from 'mdi-react/ViewGridIcon';
import CompactListIcon from 'mdi-react/ViewListIcon';
import { LayoutMode } from './types';

import * as S from './styles';

type Props = {
  mode: LayoutMode;
  active: boolean;
  onClick: (mode: LayoutMode) => void;
};

const LayoutPicker = ({ mode, onClick, active }: Props) => {
  const { t } = useContext(AppContext);

  const setListMode = useCallback(() => onClick(mode), [mode, onClick]);

  return (
    <S.LayoutButton
      onClick={setListMode}
      aria-label={t(
        'category',
        mode === LayoutMode.GRID
          ? 'product-list.grid-layout-button'
          : 'product-list.list-layout-button'
      )}
      active={active}
      data-test={`layout-button-${mode}`}
    >
      <Icon mode={mode} />
    </S.LayoutButton>
  );
};

const Icon = ({ mode }: { mode: LayoutMode }) => {
  switch (mode) {
    case LayoutMode.GRID:
      return <GridIcon size={24} />;
    case LayoutMode.LIST:
      return <ListIcon size={24} />;
    case LayoutMode.TABLE:
      return <TableIcon size={24} />;
    case LayoutMode.COMPACT_LIST:
      return <CompactListIcon size={24} />;
    default:
      return <ListIcon size={24} />;
  }
};

export default memo(LayoutPicker);
